import './team_overview.scss';
import init_listing from 'components/listing/Listing';

function init() {
	init_listing('#team_listing_items', {
		query_all: 'team_overview/ajax_query_all',
		search_input: '#listing_filter_search',
		filters: [
			{
				el: '#listing_filter_category',
				type: 'dropdown',
				key: 'categories',
			},
		],
		sort: '#listing_sort',
		load_more: true,
		load_more_auto: true,
		transition_duration: 300,
		items_data: listings_data.items,
		post_count: parseInt(listings_data.post_count),
		found_posts: parseInt(listings_data.found_posts),
		query_args: listings_data.query_args,
	});
}

// Only run when the listing markup + data are actually present. This script can be
// loaded (via the page's vite_scripts field) on pages that render the team with the
// ff_query widget, which provides no #team_listing_items container and no
// `listings_data` global — in which case there's nothing to initialise.
if (
	document.querySelector('#team_listing_items') &&
	typeof listings_data !== 'undefined'
) {
	init();
}
